import { BrowserModule } from '@angular/platform-browser';
import {
  NgModule,
  LOCALE_ID,
  APP_INITIALIZER,
  ErrorHandler
} from '@angular/core';
import { AppComponent } from './app.component';
import { SharedModule } from './_shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppStoreModule } from './store/app-store.module';
import { ThemeService, LoadService, AgentService } from './_shared/services';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { icons } from './_shared/icons/icons';
import {
  StorageService,
  LayoutService,
  STORAGE_PREFIX,
  TURNSTILE_SITE_KEY,
  MetadataService,
  METADATA_GLOBAL,
  ENV_VARS,
  SpinnerModule,
  SentryErrorHandler,
  // SENTRY_DSN,
  DetectDeviceService,
  ScrollService,
  WindowRef,
  FacebookService
} from '@apps/ui';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { DialogErrorModule, AlertMessagesModule } from './_shared/components';
import { WidgetElementsModule } from './_shared/components/widget-elements/widget-elements.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorInterceptor } from './_shared/interceptors';
import { ShortLinkModule } from './pages/short-link/short-link.module';
import {
  FontAwesomeModule,
  FaIconLibrary
} from '@fortawesome/angular-fontawesome';
import { DEFALUT_METADATA } from './_shared/texts';
import { APP_BASE_HREF, Location } from '@angular/common';
import { environment } from '../environments/environment';

registerLocaleData(localePl, 'pl');

export function init_app(load: LoadService) {
  return () => load.initializeApp();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    ShortLinkModule,
    TransferHttpCacheModule,
    FontAwesomeModule,
    AppRoutingModule,
    SharedModule,
    DialogErrorModule,
    BrowserAnimationsModule,
    AppStoreModule,
    SpinnerModule,
    AlertMessagesModule,
    WidgetElementsModule
  ],
  providers: [
    WindowRef,
    ThemeService,
    StorageService,
    LayoutService,
    LoadService,
    AgentService,
    MetadataService,
    DetectDeviceService,
    ScrollService,
    FacebookService,
    ThemeService,
    { provide: LOCALE_ID, useValue: 'pl' },
    { provide: STORAGE_PREFIX, useFactory: () => 'sc' },
    { provide: ENV_VARS, useFactory: () => environment },
    {
      provide: METADATA_GLOBAL,
      useFactory: () => DEFALUT_METADATA
    },
    {
      // Cloudflare Turnstile - ten sam widget/klucze co zatrzymajlicznik.pl.
      // Dev: klucz testowy CF (1x000...AA, zawsze przechodzi) z .env.local.
      provide: TURNSTILE_SITE_KEY,
      useFactory: () => process.env.SC_TURNSTILE_SITE_KEY
    },
    // {
    //   provide: SENTRY_DSN,
    //   useValue: environment.sentry
    // },
    // { provide: ErrorHandler, useClass: SentryErrorHandler },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [LoadService],
      multi: true
    },
    { provide: APP_BASE_HREF, useValue: '/porownywarka' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(...icons);
  }
}
